<template>
  <!-- prompt 一键复制（详情弹窗 Prompt 标题右侧用），Copied 状态 1.5s 复原 -->
  <button type="button" class="copy-btn" title="Copy prompt" @click="copy">
    <svg v-if="copied" class="ok" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
    <svg v-else width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
    </svg>
    {{ copied ? 'Copied' : 'Copy' }}
  </button>
</template>

<script setup lang="ts">
import { useSnackbarStore } from '~/composables/useSnackBarStore';

const props = defineProps<{ text: string }>();

const copied = ref(false);
let timer: number | null = null;
const copy = async () => {
  try {
    await navigator.clipboard.writeText(props.text);
    copied.value = true;
    if (timer !== null) window.clearTimeout(timer);
    timer = window.setTimeout(() => { copied.value = false; }, 1500);
  } catch {
    useSnackbarStore().showError('Copy failed');
  }
};
onBeforeUnmount(() => { if (timer !== null) window.clearTimeout(timer); });
</script>

<style scoped>
.copy-btn {
  display: inline-flex; align-items: center; gap: 0.25rem;
  padding: 2px 6px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 0.35rem;
  background: transparent;
  color: rgba(255, 255, 255, 0.55);
  font-size: 10px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.copy-btn:hover { background: rgba(255, 255, 255, 0.08); color: white; }
.copy-btn .ok { color: #34d399; }
</style>
